// extracted by mini-css-extract-plugin
module.exports = {"container":"HowDoWePayYouTab_container__3xBrQ","dropdown":"HowDoWePayYouTab_dropdown__3SbkB"};